import { FC, useContext, useState } from 'react';

import { BottomIcon, StarIcon, TopIcon } from '@smartshell/ui-kit';
import cn from 'classnames';

import { LocalizationContext } from 'localization';

import { IClubReviewsResponse } from '../interfaces';
import { Rate } from '../Rate';
import s from './Summary.module.scss';

interface IRateProps {
  data?: IClubReviewsResponse['clubComments']['summary'];
}
export const Summary: FC<IRateProps> = ({ data }) => {
  const { t } = useContext(LocalizationContext);

  const totalCount = data
    ? data.five + data.four + data.three + data.two + data.one
    : '-';

  const [isOpen, setIsOpen] = useState<boolean>(false);
  return (
    <div className={s.container}>
      <div className={s.block}>
        <span className={s.title}>{t('reviews.rate')}</span>
        <div className={cn(s.row, s.average)}>
          {data?.average_grade.toFixed(1) ?? '-'}
          <StarIcon color="violet" size="xl" />
        </div>
      </div>
      {Boolean(data) && (
        <div className={cn(s.block, s.block_desktop)}>
          <div className={s.row}>
            <span>{t('reviews.rates.total')}</span>
            {totalCount}
          </div>
          <div className={s.row}>
            <Rate rate={5} />
            {data?.five}
          </div>
          <div className={s.row}>
            <Rate rate={4} />
            {data?.four}
          </div>
          <div className={s.row}>
            <Rate rate={3} />
            {data?.three}
          </div>
          <div className={s.row}>
            <Rate rate={2} />
            {data?.two}
          </div>
          <div className={s.row}>
            <Rate rate={1} />
            {data?.one}
          </div>
        </div>
      )}
      {Boolean(data) && (
        <div className={s.block_mobile}>
          <div
            className={s.row}
            onClick={() => {
              setIsOpen(!isOpen);
            }}
          >
            <span className={s.all}>
              {t('reviews.rates.total')} {isOpen ? <TopIcon /> : <BottomIcon />}
            </span>
            {totalCount}
          </div>
          {isOpen && (
            <div className={s.dropdown}>
              <div className={s.row}>
                <Rate rate={5} />
                {data?.five}
              </div>
              <div className={s.row}>
                <Rate rate={4} />
                {data?.four}
              </div>
              <div className={s.row}>
                <Rate rate={3} />
                {data?.three}
              </div>
              <div className={s.row}>
                <Rate rate={2} />
                {data?.two}
              </div>
              <div className={s.row}>
                <Rate rate={1} />
                {data?.one}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
